<template>
    <div class="animated fadeIn">
        <AppHeader closeable="true" title="Something went wrong!"></AppHeader>
        <section class="container">
            <div class="intro-content pt--40 pb--20">
                <div class="profile profile--vertical profile--lg mb--30">
                    <figure class="profile__avatar">
                    <span class="profile__avatar__img">
                        <img src="img/pictures/avatar-1.jpg" alt="" />
                    </span>
                    </figure>

                    <div class="profile__text">
                        <div class="profile__name">Error 500</div>
                        <div class="opacity--sm">{{ message }}</div>
                    </div>
                </div>

            </div>

            <router-link to="/" class="btn btn--block btn--primary mt--30 mb--lg">
                Go to Dashboard
            </router-link>
        </section>
    </div>

</template>

<script>
    import AppHeader from './partial/AppHeader'

    export default {
        name: "Error",
        components: {AppHeader},
        data: function () {
            return {
                redirect: null,
            }
        },
        created() {
            this.redirect = get(this.$router.currentRoute.query, 'redirect')
        },

        computed: {
            message() {
                if (get(this.$router.currentRoute.query, 'code') == 450) {
                    return 'You already have an open connection in other browser window!'
                }

                if (get(this.$router.currentRoute.query, 'code') == 401) {
                    return 'Unauthorized! Please login first!'
                }

                return 'Can\'t connect to server. Please try again later.';
            }
        }
    }
</script>
